import { FC} from "react";

import {DocumentEditor} from "@onlyoffice/document-editor-react";
import {FILE_API_BASE_URL, ONLY_OFFICE_API_BASE_URL} from "../utils/config";

interface EditorProps {
    onBack?: () => void;
}

const SpreadsheetEditor: FC<EditorProps> = ({ onBack }) => {
    const documentKey = `spreadsheet-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

    return (
        <div style={{ maxWidth: "100%", margin: "0 auto", padding: "40px" }}>
            {/* Back Button */}
            {onBack && (
                <button
                    onClick={onBack}
                    style={{
                        background: "transparent",
                        border: "none",
                        color: "#2563eb",
                        fontSize: 14,
                        fontWeight: 600,
                        cursor: "pointer",
                        marginBottom: 24,
                        padding: 0,
                        display: "flex",
                        alignItems: "center",
                        gap: 6,
                    }}
                >
                    ← Back to Home
                </button>
            )}
            <div style={{ height: "100vh", width: "100%" }}>
                <DocumentEditor
                    id="spreadsheetEditor"
                    documentServerUrl= {ONLY_OFFICE_API_BASE_URL}
                    config={{
                        document: {
                            fileType: "xls",
                            key: documentKey,
                            title: "test.xls",
                            url: FILE_API_BASE_URL+"/files/sample.xls"
                        },
                        documentType: "cell",
                        editorConfig: {
                            mode: "edit",
                            lang: "en",
                            user: {
                                id: "1",
                                name: "Aman"
                            }
                        },
                    }}
                />
            </div>
        </div>
    );
};

export default SpreadsheetEditor;